import { render } from "./NextRecordNumber.vue?vue&type=template&id=97f3952a"
import script from "./NextRecordNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./NextRecordNumber.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/elements/NextRecordNumber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "97f3952a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('97f3952a', __exports__)) {
    api.reload('97f3952a', __exports__)
  }
  
  module.hot.accept("./NextRecordNumber.vue?vue&type=template&id=97f3952a", () => {
    api.rerender('97f3952a', render)
  })

}


export default __exports__